import RucksackColor from './RucksackColour.svg';
import RucksackDark from './RucksackDark.svg';
import RucksackLight from './RucksackLight.svg';
export const rucksack = { color: RucksackColor, dark: RucksackDark, light: RucksackLight };
//# sourceMappingURL=index.js.map